module.exports = __webpack_public_path__ + "static/img/system-img-right.2ca25d62.png";